import vueVimeoPlayer from 'vue-vimeo-player'
//import SVG from 'svgjs'


import Vue from "vue"
import App from "./App.vue"

Vue.config.productionTip = false;
Vue.use(vueVimeoPlayer);
//Vue.use(SVG);


Vue.mixin({
  data: function() {
    return {
      get baseurl() {
        //return '/';
        return '/elf/apps/intergenerational-map/INTERGENERATIONALMAPEN/';
      }
    };
  },
});


new Vue({
  render: (h) => h(App)
}).$mount("#app");
